<template>
  <b-row>
    <b-col cols="12">
      <sites-account-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SitesAccountTable from './SitesAccountTable.vue'

export default {
  components: {
    BRow,
    BCol,
    SitesAccountTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
